import { T } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
export function DeadlineCard({ deadlineDays }: { deadlineDays: number }) {
  return (
    <Flex flexDirection="column" gap="sm">
      <Text fontWeight="bold">
        <T>Deadline</T>
      </Text>
      <Text>
        <T count={deadlineDays}>
          You must ship your package within {{ deadlineDays }} days.
        </T>
      </Text>
    </Flex>
  );
}
